import {settingsBlockedUserPath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'

export async function unblockUserPersonally(userLogin: string, navigationSource?: string): Promise<void> {
  const path = settingsBlockedUserPath({login: userLogin})
  const url = navigationSource ? `${path}?${new URLSearchParams({navigation_source: navigationSource})}` : path
  const response = await verifiedFetch(url, {
    method: 'DELETE',
    redirect: 'manual',
  })

  if (!response.ok && response.type !== 'opaqueredirect') {
    throw new Error('Failed to unblock user')
  }
}
